module.exports = __webpack_public_path__ + "static/media/graph.fdd7d487.png";